export const APPLICATIONS_LIST = "APPLICATIONS_LIST";
export const AUTHORIZATION_LIST = "AUTHORIZATION_LIST";
export const COMFLOW_SESSION_ID = "COMFLOW_SESSION_ID";
export const EMBEDDED_SESSION_ID = "EMBEDDED_SESSION_ID";
export const INITIALIZED = "INITIALIZED";
export const IS_SINGLE_SIGN_ON = "IS_SINGLE_SIGN_ON";
export const LOGIN_TOKEN = "SET_MYLOC_LOGIN_TOKEN";
export const MAIN_SESSION_ID = "MAIN_SESSION_ID";
export const REMEMBER_ME = "REMEMBER_ME";
export const RESET_COMFLOW_SESSION_ID = "RESET_COMFLOW_SESSION_ID";
export const RESET_SESSION = "RESET_SESSION";
export const RESET_SESSION_INITIALIZED = "RESET_SESSION_INITIALIZED";
export const SESSION_ID = "SESSION_ID";
export const SINGLE_SIGN_OUT = "SINGLE_SIGN_OUT";
export const SESSION_INITIALIZED = "SESSION_INITIALIZED";
export const USER_HAS_MESSAGE_TO_ACCEPT = "USER_HAS_MESSAGE_TO_ACCEPT";
export const QLIK_LOGIN_URL = "QLIK_LOGIN_URL";
